import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType,} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { configVignettes_template } from "../components/templates/configVignettes_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { header } from "./header";

declare var ko: any;
declare var page: any;

export class config_vignettes extends vnModule_knockoutJS {
    protected XHRHdl: XMLHttpRequestHandler;
    protected configVignettes: configVignettes_template;
    protected _isLeavePageWarningNeeded: boolean = true;

    public fillPage(): void {
        this.getSettings();
    }

    buildContent(): Array<Element> {
        this.configVignettes = new configVignettes_template("config_vignettes", this.viewModel, this);

        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Vignette Settings");

        return [this.configVignettes.build()];
    }

    protected getModuleName(): string {
        return "config_vignettes";
    }

    protected getSettings(): void {
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        const usrReq_url: string = "/api/brand/" + idBrand + "/generalconfig/vignette-settings/get/";
        const usrReq_params: Array<Array<string>> = [];

        this.loadingIn(this.configVignettes.builtTemplate);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetSettingsReturn;
        this.XHRHdl.execute();
    }

    protected onGetSettingsReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                const response = responseParsed.data || {};
                obj.configVignettes.setBrandReferences(response.brand_references || {});
            });
            obj.loadingOut(obj.configVignettes.builtTemplate);
        };
    }

    public saveSettings(): void {
        this.loadingIn(this.configVignettes.builtTemplate);

        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        const formReq_url: string = "/api/brand/" + idBrand + "/generalconfig/vignette-settings/save/";
        const formReq_params: Array<Array<string>> = [];
        const subViewModel = this.configVignettes.getVignetteSettings();

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        const xhrHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        xhrHdl.mode = XMLHttpRequestHandler_requestType.POST;
        xhrHdl.onReadyStateFunction = this.onSaveSettingsReturn;
        xhrHdl.execute();
    }

    protected onSaveSettingsReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const idBrand = obj.getVnAppZone().getApp().params.idBrand;
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    "SAVED!"
                );
                page.redirect("/brand/" + idBrand + "/config/vignettes/");
            });
            obj.loadingOut(obj.configVignettes.builtTemplate);
        };
    }

    public cancelSettings(): void {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect("/brand/" + idBrand + "/articles/");
    }
}



// WEBPACK FOOTER //
// ./js/modules/config_vignettes.ts